import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationLayoutComponent } from './autenticacao/authentication-layout/authentication-layout.component';
import { ColaboradorAuthenticationPageComponent } from './autenticacao/colaborador-authentication-page/colaborador-authentication-page.component';
import { LoginPageComponent } from './autenticacao/login-page/login-page.component';
import { CadastroPageComponent } from './cadastro/cadastro-page/cadastro-page.component';
import { ConfirmarCadastroPageComponent } from './cadastro/confirmar-cadastro-page/confirmar-cadastro-page.component';
import { ContratoPageComponent } from './contrato/contrato-page/contrato-page.component';
import { RenegocicaoPageComponent } from './contrato/renegocicao-page/renegocicao-page.component';
import { SegundaViaParcelaPageComponent } from './contrato/segunda-via-parcela-page/segunda-via-parcela-page.component';
import { AccountRecoveryPageComponent } from './password-recovery-external/account-recovery-page/account-recovery-page.component';
import { PasswordChangePageComponent } from './password-recovery-external/password-change-page/password-change-page.component';
import { TokenConfirmationPageComponent } from './password-recovery-external/token-confirmation-page/token-confirmation-page.component';
import { VerificationMethodSelectionPageComponent } from './password-recovery-external/verification-method-selection-page/verification-method-selection-page.component';
import { AccountConfirmationPageComponent } from './perfil/account-confirmation-page/account-confirmation-page.component';
import { AlterarSenhaPerfilPageComponent } from './perfil/alterar-senha-perfil-page/alterar-senha-perfil-page.component';
import { PerfilPageComponentComponent } from './perfil/perfil-page-component/perfil-page-component.component';
import { ProfileTokenConfirmationPageComponent } from './perfil/profile-token-confirmation-page/profile-token-confirmation-page.component';
import { SelecaoCanalValidacaoPageComponent } from './perfil/selecao-canal-validacao-page/selecao-canal-validacao-page.component';
import { AutenticaoGuardService } from './seguranca/autenticacao-guard';
import { CanDeactivateGuard } from './seguranca/can-deactivate.guard';
import { ValidationGuard } from './seguranca/validation.guard';
import { LayoutComponent } from './shared/layout/layout.component';
import { StepperOverviewComponent } from './stepper-overview/stepper-overview.component';
import { InstallmentListPageComponent } from './second-copy-installment/installment-list-page/installment-list-page.component';
import { CheckoutPixPageComponent } from './checkout/checkout-pix-page/checkout-pix-page.component';
import { CheckoutBoletoPageComponent } from './checkout/checkout-boleto-page/checkout-boleto-page.component';
import { RenegotiationResumePageComponent } from './renegotiation-resume/renegotiation-resume-page/renegotiation-resume-page.component';
import { CheckoutPixRenegociacaoPageComponent } from './checkout/checkout-pix-renegociacao-page/checkout-pix-renegociacao-page.component';
import { CheckoutBoletoRenegociacaoComponent } from './checkout/checkout-boleto-renegociacao/checkout-boleto-renegociacao.component';
import { HomePageComponent } from './home/home-page/home-page.component';
import { Bandeira } from './shared/models/bandeira.enum';
import { BrandRouteGuard } from './seguranca/brand-route.guard';
import { ListaCartoesPageComponent } from './renegociacao-cartao/lista-cartoes-page/lista-cartoes-page.component';
import { PropostasPageComponent } from './renegociacao-cartao/propostas-page/propostas-page.component';
import { AceitarTermosComponent } from './renegociacao-cartao/aceitar-termos/aceitar-termos.component';
import { CheckoutPageComponent } from './renegociacao-cartao/checkout-page/checkout-page.component';
import { AcompanharAcordoPageComponent } from './renegociacao-cartao/acompanhar-acordo-page/acompanhar-acordo-page.component';

const routes: Routes = [
  { path: '', component: LoginPageComponent, data: { showInfo: true } },
  { path: 'cadastro', component: CadastroPageComponent },
  { path: 'recuperar-senha', component: VerificationMethodSelectionPageComponent },
  { path: 'recuperar-senha/confirmar-token', component: TokenConfirmationPageComponent },
  { path: 'recuperar-senha/alterar', component: PasswordChangePageComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'recuperar-senha/confirmar-dados', component: AccountRecoveryPageComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'auth/colaborador', component: ColaboradorAuthenticationPageComponent },
  {
    path: 'portal',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: HomePageComponent,

        data: { newUX: true, blockedBrand: Bandeira.PONTOFRIO, redirectTo: '/portal/contratos' },
        canActivate: [AutenticaoGuardService, BrandRouteGuard], canLoad: [AutenticaoGuardService]
      },
      { path: 'contratos', component: ContratoPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService] },
      { path: 'renegociacao', component: StepperOverviewComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService] },
      { path: 'contratos/:idContrato/segundavia', data: { newUX: true }, component: InstallmentListPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService] },
      { path: 'contratos/:idContrato/segundavia/:numeroParcela/checkout/pix', data: { newUX: true }, component: CheckoutPixPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService] },
      { path: 'contratos/:idContrato/segundavia/:numeroParcela/checkout/boleto', data: { newUX: true }, component: CheckoutBoletoPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService] },
      {
        path: 'contratos/:idContrato/segundavia/:numeroParcela',
        component: SegundaViaParcelaPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'contratos/:idContrato/renegociacao',
        component: RenegocicaoPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'contratos/:idContrato/renegociacao/:idPlano/resumo',
        component: RenegotiationResumePageComponent, data: { newUX: true }, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'contratos/:idContrato/renegociacao/:idPlano/checkout/pix',
        component: CheckoutPixRenegociacaoPageComponent, data: { newUX: true }, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'contratos/:idContrato/renegociacao/acordo-vigente/checkout/pix',
        component: CheckoutPixRenegociacaoPageComponent, data: { newUX: true }, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'contratos/:idContrato/renegociacao/:idPlano/checkout/boleto',
        component: CheckoutBoletoRenegociacaoComponent, data: { newUX: true }, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'contratos/:idContrato/renegociacao/acordo-vigente/checkout/boleto',
        component: CheckoutBoletoRenegociacaoComponent, data: { newUX: true }, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'perfil',
        component: PerfilPageComponentComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'perfil/validacao/alterar/:tipoAlteracao',
        component: SelecaoCanalValidacaoPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'perfil/alterar/:tipoAlteracao/confirmar-token',
        component: ProfileTokenConfirmationPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService]
      },
      {
        path: 'perfil/alterar/:tipoAlteracao/confirmar-conta',
        component: AccountConfirmationPageComponent, canActivate: [AutenticaoGuardService], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'perfil/alterar/senha',
        component: AlterarSenhaPerfilPageComponent, canActivate: [AutenticaoGuardService, ValidationGuard], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'renegociacao/cartao/lista-cartoes',
        data: { newUX: true, blockedBrand: Bandeira.PONTOFRIO, redirectTo: '/portal/contratos', breadcrumb: 'Renegociação cartão' },
        component: ListaCartoesPageComponent, canActivate: [AutenticaoGuardService, BrandRouteGuard], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'renegociacao/cartao/lista-cartoes/propostas',
        data: { newUX: true, blockedBrand: Bandeira.PONTOFRIO, redirectTo: '/portal/contratos', breadcrumb: 'Renegociação cartão > Visualizar proposta' },
        component: PropostasPageComponent, canActivate: [AutenticaoGuardService, BrandRouteGuard], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'renegociacao/cartao/lista-cartoes/aceitar-termos',
        data: { newUX: true, blockedBrand: Bandeira.PONTOFRIO, redirectTo: '/portal/aceitar-termos', breadcrumb: 'Renegociação cartão > Visualizar proposta > Contratar acordo' },
        component: AceitarTermosComponent, canActivate: [AutenticaoGuardService, BrandRouteGuard], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'renegociacao/cartao/lista-cartoes/propostas/checkout/boleto',
        data: { newUX: true, blockedBrand: Bandeira.PONTOFRIO, redirectTo: '/portal/contratos', breadcrumb: 'Renegociação cartão > Visualizar proposta > Contratar acordo > Pagamento acordo' },
        component: CheckoutPageComponent, canActivate: [AutenticaoGuardService, BrandRouteGuard], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'renegociacao/cartao/lista-cartoes/acordo/:debtId/checkout/boleto',
        data: { newUX: true, blockedBrand: Bandeira.PONTOFRIO, redirectTo: '/portal/contratos', fromAgreementListPage: true, breadcrumb: 'Renegociação cartão > Acompanhar acordo > Emitir boleto' },
        component: CheckoutPageComponent, canActivate: [AutenticaoGuardService, BrandRouteGuard], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'renegociacao/cartao/lista-cartoes/acordo/:debtId',
        data: { newUX: true, blockedBrand: Bandeira.PONTOFRIO, redirectTo: '/portal/contratos', breadcrumb: 'Renegociação cartão > Acompanhar acordo' },
        component: AcompanharAcordoPageComponent, canActivate: [AutenticaoGuardService, BrandRouteGuard], canLoad: [AutenticaoGuardService], canDeactivate: [CanDeactivateGuard]
      },
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { }
